import React from 'react';

const EarthIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M21.9 21.39c-.26-.8-1.01-1.39-1.9-1.39h-1v-3a1 1 0 0 0-1-1h-6v-2h2a1 1 0 0 0 1-1v-2h2a2 2 0 0 0 2-2v-.41a7.984 7.984 0 0 1 2.9 12.8M15 23.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.22.21-1.79L13 19v1a2 2 0 0 0 2 2m1-16C10.477 6 6 10.477 6 16A10 10 0 1 0 16 6z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default EarthIcon;
